import {
    BOTAO_RELEVO_PRIMARIO,
    BOTAO_RELEVO_PERIGO,
    BOTAO_RELEVO_SECUNDARIO,
    INPUT_AFUNDADO
} from 'src/utils/buttonStyles';

// Os tokens compõem strings sem twMerge, então quem recebe um BOTAO_RELEVO_*
// não pode repetir bg/border/shadow próprios — só tamanho e layout.
export const CHATS_ARQUIVADAS_DESIGN = {
    layout: {
        container: "flex h-full w-full overflow-hidden animate-in fade-in duration-500",
        main: "flex-1 flex flex-col min-w-0 h-full overflow-hidden bg-gray-100/70",
        content: "flex-1 flex flex-col gap-4 p-5 min-h-0 overflow-hidden"
    },
    sidebar: {
        container: "w-[280px] flex-shrink-0 h-full border-r border-gray-100 bg-white flex flex-col transition-[width] duration-200",
        containerRecolhido: "w-[60px] flex-shrink-0 h-full border-r border-gray-100 bg-white flex flex-col transition-[width] duration-200",
        toggle: `w-7 h-7 rounded-lg flex items-center justify-center flex-shrink-0 ${BOTAO_RELEVO_SECUNDARIO}`,
        toggleRow: "flex items-center justify-between px-3 pt-3",
        railList: "flex-1 overflow-y-auto px-2 pt-2 space-y-1",
        railItem: "relative w-9 h-9 mx-auto rounded-xl flex items-center justify-center transition-all cursor-pointer",
        railItemActive: "bg-violet-50 ring-1 ring-[#7C3AED]/30",
        railItemIdle: "hover:bg-gray-50",
        railBadge: "absolute -top-1 -right-1 min-w-[16px] h-4 px-1 rounded-full bg-[#7C3AED] text-white text-[9px] font-bold flex items-center justify-center",
        search: "px-4 pt-2 pb-3",
        searchInput: `w-full pl-9 pr-3 py-2 text-sm border rounded-xl focus:outline-none ${INPUT_AFUNDADO}`,
        sectionLabel: "text-xs font-semibold text-gray-500 uppercase tracking-wider",
        sectionHeader: "flex items-center justify-between px-4 pb-2",
        addButton: `w-6 h-6 rounded-lg flex items-center justify-center ${BOTAO_RELEVO_PRIMARIO}`,
        list: "flex-1 overflow-y-auto px-2 space-y-0.5",
        item: "group w-full flex items-center gap-2.5 px-2.5 py-2 rounded-xl text-sm transition-all cursor-pointer",
        itemActive: "bg-violet-50 text-[#7C3AED] font-medium",
        itemIdle: "text-gray-600 hover:bg-gray-50",
        itemHandle: "opacity-0 group-hover:opacity-100 text-gray-300 transition-opacity cursor-grab",
        itemCount: "ml-auto text-xs text-gray-400 font-medium tabular-nums",
        newDivision: "mx-4 my-3 flex items-center justify-center gap-2 px-3 py-2.5 text-sm text-gray-500 border border-dashed border-gray-200 rounded-xl hover:border-[#7C3AED] hover:text-[#7C3AED] hover:-translate-y-px active:translate-y-px transition-all duration-200 ease-out",
        infoCard: "mx-4 mb-4 p-3.5 bg-gray-50/80 rounded-xl border border-gray-100",
        infoTitle: "flex items-center gap-2 text-xs font-semibold text-gray-700 mb-2.5",
        infoItem: "flex items-start gap-2 text-[11px] text-gray-500 leading-relaxed mb-2 last:mb-0"
    },
    toolbar: {
        container: "flex flex-col md:flex-row md:items-center gap-3",
        searchWrapper: "relative flex-1 max-w-md",
        searchInput: `w-full pl-9 pr-3 py-2.5 text-sm border rounded-xl focus:outline-none ${INPUT_AFUNDADO}`,
        searchIcon: "absolute left-3 top-1/2 -translate-y-1/2 text-gray-400",
        viewToggle: "flex items-center gap-1 p-1 bg-gray-100 rounded-xl",
        viewButton: "flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-lg transition-all",
        viewButtonActive: "bg-white text-gray-900 shadow-sm",
        viewButtonIdle: "text-gray-500 hover:text-gray-700"
    },
    lista: {
        container: "flex flex-row gap-3 flex-1 min-h-0 overflow-hidden",
        coluna: "w-[360px] min-w-[320px] flex-shrink-0 flex flex-col bg-white rounded-2xl border border-gray-100 overflow-hidden",
        colunaScroll: "flex-1 overflow-y-auto",
        carregarMais: "w-full py-2.5 text-xs font-medium text-[#7C3AED] hover:bg-violet-50 transition-colors border-t border-gray-100",
        painel: "flex-1 flex flex-col min-w-0 bg-white rounded-2xl border border-gray-100 overflow-hidden",
        painelVazio: "flex flex-col items-center justify-center h-full p-12 text-center",
        painelVazioIcone: "w-16 h-16 bg-violet-50 rounded-2xl flex items-center justify-center mb-5 text-[#7C3AED]",
        painelVazioTitulo: "text-base font-bold text-gray-900 mb-1.5",
        painelVazioTexto: "text-sm text-gray-500 max-w-sm"
    },
    board: {
        container: "flex flex-row gap-3 overflow-x-auto pb-2 flex-1 min-h-0",
        column: "flex flex-col w-[300px] flex-shrink-0 bg-gray-200/45 rounded-2xl h-fit max-h-full",
        columnHeader: "flex items-center gap-2 px-4 pt-3 pb-2",
        columnTitle: "text-sm font-semibold text-gray-900 truncate",
        columnCount: "ml-auto text-xs font-medium text-gray-400 tabular-nums",
        columnMenu: "w-6 h-6 rounded-lg text-gray-400 hover:bg-white/80 hover:text-gray-600 flex items-center justify-center transition-all",
        columnBody: "flex-1 overflow-y-auto px-2 pb-2 space-y-1.5 min-h-[120px]",
        columnBodyDragging: "bg-violet-100/50 rounded-xl",
        columnFooter: "px-3 py-2.5 border-t border-gray-200/60",
        addCard: "w-full flex items-center justify-center gap-1.5 py-1.5 text-xs text-gray-400 hover:text-[#7C3AED] transition-colors"
    },
    card: {
        container: "bg-white rounded-lg border border-gray-200/60 p-2 shadow-[0_1px_2px_rgba(16,24,40,0.06)] hover:shadow-[0_4px_10px_rgba(16,24,40,0.1)] hover:-translate-y-px transition-all duration-200 cursor-pointer group",
        containerDragging: "shadow-xl ring-2 ring-[#7C3AED]/30 rotate-1",
        header: "flex items-start gap-1.5",
        avatar: "w-6 h-6 rounded-full flex items-center justify-center text-[9px] font-bold text-white flex-shrink-0",
        name: "text-xs font-semibold text-gray-900 truncate",
        message: "text-[10px] leading-tight text-gray-500 line-clamp-1 mt-0.5",
        menu: "w-5 h-5 rounded-md text-gray-300 hover:bg-gray-100 hover:text-gray-600 flex items-center justify-center transition-all opacity-0 group-hover:opacity-100 flex-shrink-0",
        footer: "flex items-center justify-between gap-1.5 mt-1.5 pt-1 border-t border-gray-100",
        date: "text-[9px] text-gray-400 tabular-nums",
        phone: "flex items-center gap-0.5 px-1 py-0.5 rounded bg-green-50 text-[9px] font-medium text-green-700",
        unread: "w-1.5 h-1.5 rounded-full bg-[#7C3AED] flex-shrink-0"
    },
    empty: {
        container: "flex flex-col items-center justify-center flex-1 text-center px-6 py-12",
        iconBox: "w-16 h-16 rounded-2xl bg-violet-50 flex items-center justify-center mb-4 text-[#7C3AED]",
        title: "text-lg font-bold text-gray-900 mb-1.5",
        subtitle: "text-sm text-gray-500 max-w-sm mb-4",
        action: "text-sm font-medium text-[#7C3AED] hover:underline",
        actionButton: "inline-flex items-center gap-2 px-4 py-2.5 bg-[#7C3AED] hover:bg-[#6d28d9] text-white text-sm font-medium rounded-xl transition-all shadow-sm shadow-[#7C3AED]/20 active:transform active:scale-95",
        hint: "flex items-start gap-2.5 px-3.5 py-2.5 rounded-xl bg-amber-50 border border-amber-100 text-[13px] leading-[1.5] text-amber-800 text-left max-w-sm",
        hintIcon: "text-amber-500 flex-shrink-0 mt-px"
    },
    alert: {
        container: "flex items-center gap-3 px-4 py-3 bg-violet-50 border border-violet-100 rounded-xl animate-in fade-in slide-in-from-top-2 duration-300",
        iconBox: "w-8 h-8 rounded-xl bg-[#7C3AED] flex items-center justify-center text-white flex-shrink-0",
        text: "text-sm text-gray-700 flex-1",
        strong: "font-semibold text-gray-900",
        close: "w-6 h-6 rounded-lg text-gray-400 hover:bg-violet-100 flex items-center justify-center transition-all"
    },
    modal: {
        backdrop: "fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 backdrop-blur-[2px] animate-in fade-in duration-200",
        container: "w-full max-w-md bg-white rounded-2xl shadow-2xl animate-in zoom-in-95 duration-200",
        header: "flex items-center gap-3 px-5 py-4 border-b border-gray-100",
        title: "text-base font-bold text-gray-900",
        subtitle: "text-xs text-gray-500 mt-0.5",
        body: "px-5 py-4 space-y-4 max-h-[60vh] overflow-y-auto",
        label: "text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5 block",
        input: "w-full px-3 py-2.5 text-sm border border-gray-200 rounded-xl focus:outline-none focus:border-[#7C3AED] focus:ring-2 focus:ring-[#7C3AED]/20 transition-all",
        footer: "flex items-center justify-end gap-2 px-5 py-3.5 border-t border-gray-100 bg-gray-50/80 rounded-b-2xl",
        cancel: "px-4 py-2 text-sm font-medium text-gray-600 hover:bg-gray-100 rounded-xl transition-all",
        confirm: `px-4 py-2 text-sm rounded-xl disabled:opacity-50 disabled:cursor-not-allowed ${BOTAO_RELEVO_PRIMARIO}`,
        danger: `px-4 py-2 text-sm rounded-xl ${BOTAO_RELEVO_PERIGO}`,
        colorDot: "w-8 h-8 rounded-xl border-2 transition-all",
        error: "flex items-center gap-2 px-3 py-2 bg-red-50 border border-red-100 rounded-xl text-xs text-red-700"
    }
};

// Paleta das divisões — o valor salvo em `cor_hex` é a chave.
export const CORES_DIVISAO = {
    violet: { bg: 'bg-violet-50', text: 'text-violet-600', dot: 'bg-violet-500', border: 'border-violet-500' },
    blue: { bg: 'bg-blue-50', text: 'text-blue-600', dot: 'bg-blue-500', border: 'border-blue-500' },
    green: { bg: 'bg-green-50', text: 'text-green-600', dot: 'bg-green-500', border: 'border-green-500' },
    amber: { bg: 'bg-amber-50', text: 'text-amber-600', dot: 'bg-amber-500', border: 'border-amber-500' },
    rose: { bg: 'bg-rose-50', text: 'text-rose-600', dot: 'bg-rose-500', border: 'border-rose-500' },
    cyan: { bg: 'bg-cyan-50', text: 'text-cyan-600', dot: 'bg-cyan-500', border: 'border-cyan-500' },
    slate: { bg: 'bg-slate-100', text: 'text-slate-600', dot: 'bg-slate-500', border: 'border-slate-500' }
};

export const getCorDivisao = (corHex) => CORES_DIVISAO[corHex] || CORES_DIVISAO.violet;

// Avatar do contato: cor estável derivada do nome (mesmo contato, mesma cor).
const AVATAR_COLORS = ['#7C3AED', '#2563EB', '#059669', '#D97706', '#DC2626', '#0891B2', '#DB2777'];

export const getCorAvatar = (nome) => {
    if (!nome) return AVATAR_COLORS[0];
    let hash = 0;
    for (let i = 0; i < nome.length; i += 1) hash = nome.charCodeAt(i) + ((hash << 5) - hash);
    return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
};

export const getIniciais = (nome) => {
    if (!nome) return '?';
    return nome.trim().split(' ').map((n) => n[0]).join('').slice(0, 2).toUpperCase();
};
